import React, { useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { FaBus } from "react-icons/fa";
import "../Styles/SelectSeatsScreen.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FaAngleDown,FaAngleUp } from "react-icons/fa";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";

const SeatComponent = ({ seat, isSelected, onSelect }) => {
    if (seat.number === "") {
        return <div className="seatbooking-aisle"></div>;
    }

    const getSeatClass = () => {
        if (!seat.isAvailable) return "seatbooking-seat seatbooking-booked";
        if (isSelected) return "seatbooking-seat seatbooking-selected";
        return "seatbooking-seat seatbooking-available";
    };

    return (
        <button
            className={getSeatClass()}
            disabled={!seat.isAvailable}
            onClick={() => onSelect(seat)}
        >
            {seat.number}
        </button>
    );
};

export default function SelectSeatsScreen() {
    const navigate = useNavigate();
    const { busId } = useParams();
    const query = new URLSearchParams(useLocation().search);
    const from = query.get("from");
    const to = query.get("to");
    const date = query.get("date");

    // ✅ Static Data
    const busDetails = {
        id: "bus123",
        price: 359,
        seatLayout: [
            [
                { id: "1A", number: "1A", isAvailable: true },
                { id: "1B", number: "1B", isAvailable: false },
                { id: "aisle1", number: "", isAvailable: false },
                { id: "1C", number: "1C", isAvailable: true },
                { id: "1D", number: "1D", isAvailable: true },
            ],
            [
                { id: "2A", number: "2A", isAvailable: true },
                { id: "2B", number: "2B", isAvailable: true },
                { id: "aisle2", number: "", isAvailable: false },
                { id: "2C", number: "2C", isAvailable: false },
                { id: "2D", number: "2D", isAvailable: true },
            ],
            [
                { id: "3A", number: "3A", isAvailable: true },
                { id: "3B", number: "3B", isAvailable: true },
                { id: "aisle3", number: "", isAvailable: false },
                { id: "3C", number: "3C", isAvailable: true },
                { id: "3D", number: "3D", isAvailable: false },
            ],
        ],
        boardingPoints: [
            {
                time: "22:45, 02 Sep",
                location:
                    "ISBT Kashmiri Gate, IntrCity Boarding Zone, Ground Floor, Arrival Block, Platform No.55,56,57,58 Inside ISBT Bus Stand (Delhi) 7300399510",
            },
            {
                time: "23:15, 02 Sep",
                location:
                    "Anand Vihar, Near Metro Station Gate No. 3, Bus Boarding Point, Delhi 7300399510",
            },
            {
                time: "23:45, 02 Sep",
                location:
                    "Akshardham Metro Station, Parking Area, Near Gate No. 2, Delhi 7300399510",
            },
            {
                time: "00:15, 03 Sep",
                location:
                    "Noida Sector 62, Near Electronic City Metro Station, Gate No. 1, Delhi NCR 7300399510",
            },
        ],

        pickupPoints: [
            {
                time: "22:45, 02 Sep",
                location:
                    "ISBT Kashmiri Gate, IntrCity Boarding Zone, Ground Floor, Arrival Block, Platform No.55,56,57,58 Inside ISBT Bus Stand (Delhi) 7300399510",
            },
            {
                time: "23:20, 02 Sep",
                location:
                    "Ghaziabad Bus Stand, Near Railway Station Road, Ghaziabad 7300399510",
            },
            {
                time: "23:50, 02 Sep",
                location:
                    "Meerut Bypass, Near Shatabdi Nagar, Opposite Metro Plaza Mall, Meerut 7300399510",
            },
            {
                time: "01:15, 03 Sep",
                location:
                    "Muzaffarnagar Bus Stand, Near GT Road, Muzaffarnagar 7300399510",
            },
        ],

    };

    const [selectedSeats, setSelectedSeats] = useState([]);
    const [boardingpoint, setBoardingpoint] = useState(null);
    const [pickuppoint, setPickuppoint] = useState(null)
    const [showBoardingPoint,setShowBoardingPoint] = useState(false);
    const [showPickupPoint,setShowPickupPoint] = useState(false);

    const handleSelectSeat = (seat) => {
        setSelectedSeats((prev) =>
            prev.some((s) => s.id === seat.id)
                ? prev.filter((s) => s.id !== seat.id)
                : [...prev, seat]
        );
    };

    const totalAmount = busDetails.price * selectedSeats.length;

    return (
        <div className="seatbooking-container">
            {/* Left Section */}
            <div className="seatbooking-left">
                <h3 className="seatbooking-heading">Select Seats</h3>
                <div className="seatbooking-layout">
                    <div className="seatbooking-driver">
                        <FaBus size={30} />
                    </div>
                    {busDetails.seatLayout.map((row, rowIndex) => (
                        <div key={rowIndex} className="seatbooking-row">
                            {row.map((seat) => (
                                <SeatComponent
                                    key={seat.id}
                                    seat={seat}
                                    isSelected={selectedSeats.some((s) => s.id === seat.id)}
                                    onSelect={handleSelectSeat}
                                />
                            ))}
                        </div>
                    ))}
                </div>
            </div>

            {/* Right Section */}
            <div className="seatbooking-right">
                <h3 className="seatbooking-heading">Select Pickup & Drop Points</h3>

                <div className="seatbooking-card" onClick={()=>setShowBoardingPoint(!showBoardingPoint)}>
                    <div style={{display:'flex',justifyContent:"space-between",marginBottom:"10px"}}>
                        <span style={{fontSize:"1.1rem",fontWeight:"600"}}>Drop Points</span>
                        {showBoardingPoint? <FontAwesomeIcon icon={faAngleUp}/>:<FontAwesomeIcon icon={faAngleDown}/>}
                    </div>

                    { showBoardingPoint && busDetails.boardingPoints.map((point, index) => (
                        <div key={index}
                            className={`seatbooking-point ${boardingpoint?.time === point.time ? "seatbooking-point-selected" : ""
                                }`} onClick={() => setBoardingpoint(point)}>
                            <p>{point.time}</p>
                            <p>{point.location}</p>
                        </div>
                    ))}
                </div>

                <div className="seatbooking-card">
                    <div style={{display:'flex',justifyContent:"space-between",marginBottom:"10px"}} onClick={()=>setShowPickupPoint(!showPickupPoint)}>
                        <span style={{fontSize:"1.1rem",fontWeight:"600"}}>Pickup Points</span>
                        {showPickupPoint? <FontAwesomeIcon icon={faAngleUp}/>:<FontAwesomeIcon icon={faAngleDown}/>}
                    </div>

                    {showPickupPoint && busDetails.pickupPoints.map((point, index) => (
                        <div key={index} className={`seatbooking-point ${pickuppoint?.time === point.time ? "pickuppointselected" : ""}`} onClick={() => setPickuppoint(point)}>
                            <p>{point.time}</p>
                            <p>{point.location}</p>
                        </div>
                    ))}
                </div>

                <div className="seatbooking-summary">
                    <p>
                        <strong>Selected Seats:</strong>{" "}
                        {selectedSeats.map((s) => s.number).join(", ") || "None"}
                    </p>
                    <p>
                        <strong>Total:</strong> ₹{totalAmount}
                    </p>
                    <button className="seatbooking-continue-btn" onClick={() => navigate("/transport-review-page")}>Continue</button>
                </div>
            </div>
        </div>
    );
}
